<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <!-- <div class="countryList">
          <div class="country">
              <span>乡镇：</span>
          </div>
          <div class="country">
              <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
          </div>
          <div class="country" v-for="(item,index) in towns" :key="index">
              <span @click="setListCheck(index, item.adcd)" :class="{ countryon: item.check }">{{item.adnm}}</span>
          </div>
      </div> -->
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">预案名称:</span>
          <div class="selcountry">
            <el-input v-model="planName" clearable placeholder="请输入名称" @change="Global.emptyQuery(planName,searchtown)"></el-input>
          </div>
          <span id="search" @click="searchtown">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column type="index" width="60" label="序号" align="center" header-align="center">
              </el-table-column>
              <el-table-column  prop="adcdnm" label="乡镇" min-width="100" align="center" >
              </el-table-column>
              <el-table-column prop="planName"  label="预案名称" min-width="100" align="center" >
              </el-table-column>
              <el-table-column prop="publishTime"  label="发布时间" min-width="100" align="center" >
              </el-table-column>
              <el-table-column prop="summary" :show-overflow-tooltip="true" label="内容摘要" min-width="100" align="center" >
              </el-table-column>
              <el-table-column prop="time" label="操作" min-width="80" align="center" header-align="center">
                  <template slot-scope="scope">
                    <el-button @click="downloadbtn(scope.row.planSrc)" type="primary" size="small" class='download'  title="下载">下载</el-button>
                  </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
     <el-dialog
      class="abow_dialog"
      :close-on-click-modal="false"
      :title="status + '预案信息'"
      :visible.sync="addbtn"
      >
      <el-form ref="groupForm" :rules="rules" :model="form" label-width="170px" label-height="40px">
        <el-form-item label="乡镇:" prop="adcdid">
          <el-cascader
            v-model="form.adcdid"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover' ,checkStrictly: true }"
            >
          </el-cascader>
        </el-form-item>
        <el-form-item label="预案名称:" prop="planName">
          <el-input v-model="form.planName"></el-input>
        </el-form-item>
        <el-form-item label="发布时间:" prop="publishTime">
          <el-date-picker
            v-model="form.publishTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="内容摘要:" class="textArea">
          <el-input :rows="4" type="textarea" v-model="form.summary"></el-input>
        </el-form-item>
        <el-form-item label="预案文件上传:">
          <el-upload
            :action="Global.basePath + '/file?FileType=planinfo&format=json'"
            ref="upload"
            class="upload-demo"
            accept=".pdf,.doc,.docx,.xlsx"
            :headers="token"
            :on-remove="handleRemove"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
import TownName from '@/components/Townname/index.vue'
import { getToken } from '@/utils/auth'
export default {
  components: {
    TownName
  },
  data () {
    return {
      fileList: [],
      planName: '',
      loading: true,
      height: 10,
      form: {
        adcdid: [],
        planName: '',
        summary: '',
        publishTime: '',
        planSrc: ''
      },
      addbtn: false,
      adcdval: [],
      adcds: [],
      pageIndex: '1',
      pageSize: '100',
      tdata: [],
      isTown: true,
      searchName: '',
      delId: [],
      multipleSelection: [],
      status: '新增',
      all: true,
      adcdtotal: '',
      towns: [],
      checkarr: [],
      aDCD: '330324',
      mutiRanksAdcd: [],
      token: {},
      rules: {
        adcdid: [
          { required: true, message: '请选择乡镇' }
        ],
        publishTime: [
          { required: true, message: '请选择发布时间' }
        ],
        planName: [
          { required: true, message: '预案名称不能为空' }
        ]
      }
    }
  },
  methods: {
    // 乡镇选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.aDDVCD = townAdcd
      this.thedata()
    },
    handleSuccess (response, file, fileList) {
      this.fileList = [{ name: response[0].name, url: response[0].relPath }]
    },
    handleRemove (file, fileList) {
      this.fileList = []
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_PLAN, { aDCD: this.aDDVCD, searchName: this.planName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.loading = false
      })
    },
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcds = data.results
      })
    },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          obj.adnm = item.adnm
          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        this.thedata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
    },
    addcheckarr: function (adcd, state) {
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = '330621'
      this.towns.forEach((item) => {
        item.check = false
      })
      this.thedata()
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    adcdchange (adcd) {
      this.aDCD = adcd.substring(0, 9)
    },
    searchtown () {
      this.setAllCheck()
      this.thedata()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.fileList = []
      this.form = { adcdid: [] }
      this.form.id = 0
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.form = {}
        this.fileList = []
        this.addbtn = true
        this.Global.clearValidate(this, 'groupForm')
        this.form = Object.assign({}, this.multipleSelection[0])
        this.form.adcdid = []
        if (this.multipleSelection[0].adcdid !== '' && this.multipleSelection[0] !== undefined) {
          this.getAdcdid(this.mutiRanksAdcd, this.multipleSelection[0].adcdid)
        }
        if (this.form.planSrc !== undefined && this.form.planSrc !== '') {
          this.fileList.push({ name: this.form.planSrc, url: this.form.planSrc })
        }
      }
    },
    // 删除
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.id)
        })
        this.$confirm(`确定要删除已选择的预案信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_PLAN, { id: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      if (this.fileList.length > 0) {
        this.form['PlanSrc'] = this.fileList[0].url
      }
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          let adcdidLength = this.form.adcdid.length
          if (adcdidLength > 0) {
            this.form.adcdid = this.form.adcdid[adcdidLength - 1]
          }
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_PLAN, this.form).then(() => {
            this.loading = false
            this.addbtn = false
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.form = {}
          }).catch(() => { this.loading = false })
        }
      })
    },
    // 下载
    downloadbtn (item) {
      if (item !== undefined && item !== '') {
        window.location.href = this.Global.basePath + '/' + item
      } else {
        this.$alert('没有文件可下载', '提示')
      }
    },
    // 获取三级联动数据
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
        // for (let index = 0; index < this.mutiRanksAdcd.length; index++) {
        //   const element = this.mutiRanksAdcd[index]
        //   this.formatMutiRanksAdcd(element)
        // }
      })
    },
    formatMutiRanksAdcd (val) {
      val.value = val.adcd
      if (val.children !== null && val.children !== undefined) {
        for (let index = 0; index < val.children.length; index++) {
          const element = val.children[index]
          this.formatMutiRanksAdcd(element)
        }
      }
    },
    getAdcdid (data, val) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        if (element.value === val) {
          this.form.adcdid.unshift(element.value)
          return true
        } else if (element.children !== undefined && element.children != null) {
          let result = this.getAdcdid(element.children, val)
          if (result) {
            this.form.adcdid.unshift(element.value)
            return true
          }
        }
      }
      return false
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.getMutiRanksAdcd()
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    const token = getToken()
    if (token) {
      this.token.Authorization = `Bearer ${token}`
    }
    this.thedata()
    this.towndata()
    this.adcddata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['skt'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence >>> .el-dialog__body {
  height: 80%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
  /* height: 450px !important; */
   height: 52% !important;
}
.scence >>> .el-form-item{
  margin-left: 1%;
  width: 44% !important;
  float: left;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content .el-input {
    width: 228px;
}
.scence >>> .el-dialog__footer {
  margin-top: -30px;
}
.countryList{
  /* width: 100%; */
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.scence .textArea{
  width: 100% !important;
}
.scence .textArea >>> .el-form-item__content{
width: 70% !important;
}
</style>
